import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const FirebaseConfig = {
  apiKey: 'AIzaSyB-L9NZVrRFAY7lNU7SQek6u_JSDt-iQBQ',
  authDomain: 'rapidoo-47154.firebaseapp.com',
  projectId: 'rapidoo-47154',
  storageBucket: 'rapidoo-47154.firebasestorage.app',
  messagingSenderId: '605280800554',
  appId: '1:605280800554:web:4f7e330e727038b3e55853',
  measurementId: 'G-40M0MHB2QW'
};

const tokenConfig = {
  vapidKey:
    'BMPiNtYow71Hcc3-EVbe9eEMPFoQ7QTetrCAO2NJ-CQhj9QUn99qad3vBe3U07-N5MkG94s1vBgyuLROsaz8GLY'
};

let app, messaging;

class FcmNotification {
  static init() {
    if (!app) {
      app = initializeApp(FirebaseConfig);
      messaging = getMessaging(app);
    }
  }
  static setNotificationHandler(notificationHandler) {
    onMessage(messaging, notificationHandler);
  }

  static async getDeviceToken() {
    const token = await getToken(messaging, tokenConfig).catch((error) => {
      console.error('[FcmNotification] Failed to get token:', error);
      return null;
    });
    return token || '';
  }
}

export { FcmNotification };
